module.exports = __webpack_public_path__ + "img/pota-fb.93e55bce.jpg";